import { defineMessages } from 'react-intl';

export default defineMessages({
  unit: {
    id: 'unit',
    description: 'unit',
    defaultMessage: 'unit',
  },
  units: {
    id: 'units',
    description: 'units',
    defaultMessage: 'units',
  },
});
